import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';

import { Observable, throwError } from 'rxjs';
import { DnCharge } from '../_models';
import { ArrayResponse, BaseResponse } from '../_common';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DnChargeService {

  constructor(private http: HttpClient) { }

  getAll(filter: any, realtimeFlag: boolean): Observable<any>  { //listing
    return this.http.post(`${environment.apiUrl}/report/dn-charge/graph?realtime=${realtimeFlag}`, filter)
    .pipe(
      map((data: ArrayResponse) => {
        if(data.status !== 1 || (data.status == 1 && !data.data)){
          return null;
        }else{
          return data;
        }
      }),
      catchError(error => throwError(error.message || error))
    );
  }

  export(filter: any, realtimeFlag: boolean): Observable<any> { //export
    return this.http.post(`${environment.apiUrl}/report/dn-charge/export?realtime=${realtimeFlag}`, filter);
  }

}
